import validate from 'lib/utils/validationRules';
import { formatAmount, normalizeAmount } from 'lib/utils/amount';

import store from '@/store';

import WriteOffOption from './WriteOffOption';

class BillTariff {
  constructor(data = {}, options = {
    currency: null,
  }) {
    this.id = data?.id || null;
    this.name = data?.name || null;
    this.description = data?.description || null;
    this.contentUrl = data?.contentUrl || null;
    this.amount = this.formatAmount(data?.amount, options?.currency);
    this.oneTimePayment = data?.subscription?.oneTimePayment || false;
    this.writeOffOption = this.getCurrentWriteOffOption(data?.subscription?.per);
    this.useTrialDays = validate.isPositiveNumber(data?.subscription?.trialDays);
    this.trialDays = validate.isPositiveNumber(data?.subscription?.trialDays)
      ? String(data?.subscription?.trialDays) : '';
  }

  getAmount(currency) {
    return normalizeAmount(this.amount, currency);
  }

  formatAmount(amount, currency) {
    return formatAmount(amount, {
      significant_zeros: currency?.significant_zeros || 2,
      type: currency?.type || 'DEFAULT',
    });
  }

  getPer() {
    return this.writeOffOption.periodicity;
  }

  getCurrentWriteOffOption(activePer) {
    const options = store.getters['bills/writeOffOptions'];

    if (validate.isEmptyArray(options)) {
      return new WriteOffOption;
    }

    const preparedOptions = options.find(option => option.periodicity === activePer);

    return new WriteOffOption(preparedOptions);
  }
}

export default BillTariff;
